/**
 * Which device categories (att_device_categories) a device list asks
 * sp_dev_getInovonicsDevices for (docs/DUPLICATION_AUDIT.md, B28).
 *
 *    1 AIO                    7 Fall Detection        13 Fire Panel
 *    2 Pendant                8 Motion Detection      14 Server
 *    3 Door and Entry Sensor  9 Wander Detection      15 Pull Cord
 *    4 Receivers             10 Other                 16 Push Cord
 *    5 Repeaters             11 Pressure Sensor       17 Environmental Sensors
 *    6 Resident Station      12 Atmosphere Detection  18 SIP
 *
 * Fire panels, servers and SIP devices are never in these lists; they have their own
 * pages and tabs.
 */

/* Nurse-call devices: what a resident can be given, and what the Devices page,
   Careflow, Wellness and the report filters list. No receivers or repeaters: those
   are network infrastructure, only ever assigned to areas (user, 2026-09-29). */
export const NURSE_CALL_DEVICE_CATEGORIES = [1, 2, 3, 6, 7, 8, 9, 10, 11, 12, 15, 16, 17];

/* Devices an area can be given: the nurse-call set without the devices residents wear
   (2 Pendant, 7 Fall Detection), plus the infrastructure (4 Receivers, 5 Repeaters).
   Confirmed intended by the user, 2026-10-01. */
export const AREA_DEVICE_CATEGORIES = [1, 3, 4, 5, 6, 8, 9, 10, 11, 12, 15, 16, 17];

/** The proc's device_category_filter: a comma-separated id list. */
export const NURSE_CALL_CATEGORY_FILTER = NURSE_CALL_DEVICE_CATEGORIES.join(',');
export const AREA_CATEGORY_FILTER = AREA_DEVICE_CATEGORIES.join(',');
